import { render, staticRenderFns } from "./dashboardIntegracao.vue?vue&type=template&id=e32932f2&scoped=true&"
import script from "./dashboardIntegracao.vue?vue&type=script&lang=js&"
export * from "./dashboardIntegracao.vue?vue&type=script&lang=js&"
import style0 from "./dashboardIntegracao.vue?vue&type=style&index=0&id=e32932f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32932f2",
  null
  
)

export default component.exports